import React, { ComponentType } from "react";

import Skeleton from "antd/es/skeleton";
import cn from "classnames";

import FieldVisibilityChecker from "@mapmycustomers/shared/types/fieldModel/FieldVisibilityChecker";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";

import { EntityItemProperties } from "@app/component/RecordCard";
import { NoDataComponent } from "@app/component/RecordList/types/NoDataComponent";

import styles from "./List.module.scss";

interface ListProps<T> {
  fieldsComparator?: (a: IField, b: IField) => number;
  idGetter: (item: T) => string;
  itemComponent: ComponentType<EntityItemProperties<T>>;
  loading?: boolean;
  noData?: NoDataComponent; // can be null to show no NoData
  noDataProps?: any;
  onEmailSubscribe?: (item: T) => void;
  onEmailUnsubscribe?: (item: T) => void;
  overrideFieldVisibility?: FieldVisibilityChecker;
  records: Array<T>;
  total?: number;
}

const List = <T,>({
  fieldsComparator,
  idGetter,
  itemComponent: ItemComponent,
  loading,
  noData: NoDataComponent,
  noDataProps,
  onEmailSubscribe,
  onEmailUnsubscribe,
  overrideFieldVisibility,
  records,
  total,
}: ListProps<T>) => {
  const hasData = records.length > 0;
  const isEmpty = !hasData && !loading;

  return (
    <div className={cn(styles.container, { [styles.empty]: isEmpty })}>
      <Skeleton
        active
        className={styles.skeleton}
        loading={loading}
        paragraph={{ rows: 20, width: "100%" }}
        title={false}
      >
        {hasData ? (
          records.map((item) => (
            <ItemComponent
              entity={item}
              fieldsComparator={fieldsComparator}
              key={idGetter(item)}
              onEmailSubscribe={onEmailSubscribe ? () => onEmailSubscribe(item) : undefined}
              onEmailUnsubscribe={onEmailUnsubscribe ? () => onEmailUnsubscribe(item) : undefined}
              overrideFieldVisibility={overrideFieldVisibility}
            />
          ))
        ) : NoDataComponent ? (
          <NoDataComponent hasRecords={!!total} {...noDataProps} />
        ) : null}
      </Skeleton>
    </div>
  );
};

export default List;
